import React from 'react';
import { Badge } from 'react-bootstrap';
import { WinTimeImportResponse } from '../../common/api/dac7Service';

export const getStatusBadge = (status: string) => {
  switch (status) {
    case 'Draft':
      return <Badge bg="secondary">Luonnos</Badge>;
    case 'Generated':
      return <Badge bg="info">Generoitu</Badge>;
    case 'ExportedToFile':
      return <Badge bg="primary">Viety tiedostoon</Badge>;
    case 'SubmittedToIlmoitin':
      return <Badge bg="success">Lähetetty Ilmoittimeen</Badge>;
    case 'Corrected':
      return <Badge bg="warning">Korjattu</Badge>;
    case 'Deleted':
      return <Badge bg="danger">Poistettu</Badge>;
    default:
      return <Badge bg="secondary">{status}</Badge>;
  }
};

export const getImportStatusBadge = (status: string) => {
  switch (status) {
    case 'Pending':
      return <Badge bg="warning">Odottaa</Badge>;
    case 'InProgress':
      return <Badge bg="info">Käsittelyssä</Badge>;
    case 'Completed':
      return <Badge bg="success">Valmis</Badge>;
    case 'Failed':
      return <Badge bg="danger">Epäonnistui</Badge>;
    default:
      return <Badge bg="secondary">{status}</Badge>;
  }
};

export const formatDate = (dateString: string) =>
  new Date(dateString).toLocaleDateString('fi-FI', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });

export const getPendingRows = (imports: WinTimeImportResponse[]) =>
  imports.reduce((sum, imp) => sum + (imp.totalRows - imp.processedRows), 0);

export const getReprocessingRows = (imports: WinTimeImportResponse[]) =>
  imports.reduce((sum, imp) => sum + (imp.requiresReprocessingRows || 0), 0);

export const getRemovalRows = (imports: WinTimeImportResponse[]) =>
  imports.reduce((sum, imp) => sum + (imp.requiresRemovalRows || 0), 0);
